import logo from "../images/logo.png";

const Logo = () => {
    return <img className="home-logo" src={logo} alt="10 nights logo"/>
}

export default Logo
